<template>
  <el-tooltip content="Click to change rating" placement="top">
    <el-button
      class="rate-button-group"
      :show-timeout="0"
      type="primary"
      size="mini"
      :disabled="disabled"
      @click="$emit('click')"
    >
      <span v-if="rateValue">
        Rated {{ rateValue }}<i class="ion ion-star"></i>
      </span>
      <span v-else>Rate</span>
    </el-button>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    rateValue: { type: Number, default: null },
  },
}
</script>
